import {launchHubspotWidget} from '../utility/launchHubspotWidget.js';

export const HubspotWidget = {
  bind(element, binding) {
    if (!binding.value) return;
    element.addEventListener('click', launchHubspotWidget);
  },

  unbind(element) {
    element.removeEventListener('click', launchHubspotWidget);
  },
};
